var _ellipse, _path, _ellipse2, _path2, _ellipse3, _path3, _ellipse4, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 127,
    viewBox: "0 0 126 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 95.2972,
    cy: 97.1795,
    rx: 29.703,
    ry: 29.8211,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.5941 67.3576L96.1881 67.3576L65.5941 98.6697L65.5941 67.3576Z",
    fill: "currentColor"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.0221,
    cy: 29.8205,
    rx: 29.703,
    ry: 29.8211,
    transform: "rotate(180 30.0221 29.8205)",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7253 59.6424L29.1312 59.6424L59.7253 28.3303L59.7253 59.6424Z",
    fill: "currentColor"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.821,
    cy: 96.2967,
    rx: 29.703,
    ry: 29.8211,
    transform: "rotate(90 29.821 96.2967)",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6424 66.5941L59.6424 97.1881L28.3302 66.5941L59.6424 66.5941Z",
    fill: "currentColor"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 96.179,
    cy: 29.7033,
    rx: 29.703,
    ry: 29.8211,
    transform: "rotate(-90 96.179 29.7033)",
    fill: "#E52534"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3576 59.4059L66.3576 28.8119L97.6697 59.4059L66.3576 59.4059Z",
    fill: "#E52534"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b072b9e54c7c4c2146116d561f58f77f.svg";
export { ForwardRef as ReactComponent };